exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html{box-sizing:border-box}*,*:before,*:after{box-sizing:inherit}.canvas{position:absolute;top:0;left:0}.canvas-2d{z-index:1000}#canvas-gl{background:black}\n", ""]);

